// extracted by mini-css-extract-plugin
export default {"SignUpData":"SignUpData_SignUpData__mxztL","Title":"SignUpData_Title__V3Vxm"};